module.exports = __webpack_public_path__ + "img/bol.4128202a.svg";